import { render, staticRenderFns } from "./ComputerParkButton.vue?vue&type=template&id=3f23ed36&scoped=true"
import script from "./ComputerParkButton.vue?vue&type=script&lang=js"
export * from "./ComputerParkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f23ed36",
  null
  
)

export default component.exports